// Extrae el mensaje de un error de axios. El backend responde { error } en
// errores de negocio y { errors: [{ msg }] } en errores de validación.
export const obtenerMensajeError = (error, porDefecto = "Ocurrió un error, intenta de nuevo") => {
  // sin respuesta: no hubo conexión con el servidor (red caída o tiempo agotado)
  if (error?.request && !error.response) {
    return "Sin conexión con el servidor. Revisa tu internet e intenta de nuevo.";
  }
  const data = error?.response?.data;
  return data?.error || data?.errors?.[0]?.msg || data?.message || porDefecto;
};
